import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {app_id} from '../../../../../app/modules/config'
import {Placeholder} from 'react-bootstrap'
import {useUserStateProvider} from '../../../../../app/utils/contextProvider/UserStateProvider'

export function MenuInner() {
  const intl = useIntl()
  const {loadingMenu} = useUserStateProvider()
  const dashboardLink = '/analyze/dashboard'

  // if (loadingMenu) {
  //   return (
  //     <>
  //       <Placeholder
  //         as='p'
  //         animation='glow'
  //         className='mx-2 h-40px w-100px rounded-1 border-0 mt-4'
  //       >
  //         <Placeholder className='rounded-1 h-100 w-100 border-0' />
  //       </Placeholder>

  //       <Placeholder
  //         as='p'
  //         animation='glow'
  //         className='mx-2 h-40px w-100px rounded-1 border-0 mt-4'
  //       >
  //         <Placeholder className='rounded-1 h-100 w-100 border-0' />
  //       </Placeholder>
  //     </>
  //   )
  // }

  return (
    <>
      {/* <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to={dashboardLink} /> */}
      {/* <MenuItem title='Layout Builder' to='/builder' />

      <MenuInnerWithSub
        isMega={true}
        title='Layouts'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub> */}
    </>
  )
}
